<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <v-row align="center" justify="center" class="pa-2 ma-4">
          <v-card width="500px">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>{{ $t('activar_cuenta') }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-alert v-model="alerta.activado" :type="alerta.tipo" dense outlined>
                {{ alerta.mensaje }}
              </v-alert>
              <p class="text-right">
                <a @click="goTo('/reenviar-codigo-activacion')" class="mb-1 hand d-block body-2 primary--text"
                   v-html="$t('reenviar_activacion')"/>
              </p>
            </v-card-text>
            <v-card-actions>
              <v-row no-gutters class="mt-0">
                <v-col cols="12" class="text-right pr-3">
                  <v-btn class="mx-2" color="primary" depressed @click="goTo('/')">
                    {{ $t('inicio') }}
                  </v-btn>
                  <v-btn class="mx-2" color="primary" :disabled="!activada" depressed @click="goTo('/login')">
                    {{ $t('iniciar_sesion') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {HttpHelper} from "@/comunes/helpers/HttpHelper";
import {VueRouteHelper} from "@/comunes/helpers/VueRouteHelper";

export default {
  name: 'ActivarCuentaPagina',
  components: {},
  data: () => ({
    codigo: "",
    activada: false,
    alerta: {
      activado: false,
      tipo: "",
      mensaje: ""
    }
  }),
  created() {
    if (this.$route.query.codigo) this.codigo = this.$route.query.codigo;
  },
  mounted() {
    if (this.codigo.length === 0) {
      this.alerta.tipo = "error";
      this.alerta.mensaje = this.$t('error_codigo');
      this.alerta.activado = true;
    } else {
      this.alerta.tipo = "info";
      this.alerta.mensaje = this.$t('activando_cuenta');
      this.alerta.activado = true;
      this.activar();
    }
  },
  methods: {
    activar() {
      let params = {
        codigo: this.codigo
      };

      HttpHelper.get("auth/activar-cuenta", params)
          .then(() => {
            this.activada = true;
            this.alerta.tipo = "success";
            this.alerta.mensaje = this.$t("cuenta_activada");
            this.alerta.activado = true;
          })
          .catch((error) => {
            this.alerta.tipo = "error";
            this.alerta.mensaje = error && Object.prototype.hasOwnProperty.call(error, 'mensaje')
                ? error.mensaje : this.$t('error_activar');
            this.alerta.activado = true;
          });
    },
    goTo(path) {
      VueRouteHelper.goTo(path, this.$router);
    },
  }
};
</script>

<style lang="scss" scoped>
</style>

<style lang="scss" scoped>
</style>

<!-- @formatter:off -->
<i18n>
{
  "es": {
    "activar_cuenta": "Activar cuenta",
    "error_codigo": "No se ha recibido un código de activación correcto",
    "error_activar": "No se ha podido activar la cuenta",
    "inicio": "Ir a inicio",
    "iniciar_sesion": "Iniciar sesión",
    "activando_cuenta": "Se está activando la cuenta. Espera un momento.",
    "cuenta_activada": "La cuenta ha sido activada. Ya puedes iniciar sesión para comenzar a utilizar la aplicación.",
    "reenviar_activacion": "¿No has podido activar tu cuenta?"
  }
}
</i18n>
<!-- @formatter:on -->